import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AppDeepLinkPage() {
  const location = useLocation();

  useEffect(() => {
    // Redirect to masterbook.davinese.com preserving the full path
    window.location.replace(`https://masterbook.davinese.com${location.pathname}`);
  }, [location.pathname]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 200px)',
        padding: '48px 16px',
      }}
    >
      <p
        style={{
          fontSize: '1rem',
          color: 'var(--color-text-secondary)',
        }}
      >
        Redirecting...
      </p>
    </div>
  );
}
